import { render, staticRenderFns } from "./NewHelpModal.vue?vue&type=template&id=080b563c"
import script from "./NewHelpModal.vue?vue&type=script&lang=ts"
export * from "./NewHelpModal.vue?vue&type=script&lang=ts"
import style0 from "./NewHelpModal.vue?vue&type=style&index=0&id=080b563c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports